<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs6 sm6 md6 lg8 order-md1>
        <v-card>
          <gmap-map
          ref='map'
          :center="center"
          :zoom="zoom"
          :options= "options"
          style="width: 100%; height: 500px"
          >
          <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="false"
          @click='wellClicked(m.wellKey)'
          ></gmap-marker>
        </gmap-map>
      </v-card>
    </v-flex>
    <v-flex xs7 sm7 md5 lg 5 order-md2>
      <v-card>
        <h5>{{selectedWellName}}</h5>
        <v-container fluid>
          <v-layout row>
            <v-flex xs2 sm2 md2 lg2 order-md2>
              <v-flex d-flex>
                <v-card>
                  <water-level></water-level>
                </v-card>
              </v-flex>
            </v-flex>
            <v-flex xs10 sm10 md10 lg10 order-md3>
              <v-flex d-flex>
                <v-card>
                  <stiff-diagram></stiff-diagram>
                </v-card>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
  // import * as VueGoogleMaps from 'vue2-google-maps'
  import Vue from 'vue'
  import stiffDiagram from '../visualization/StiffDiagram.vue'
  import waterLevel from '../visualization/WaterLevel.vue'
  import * as VueGoogleMaps from 'vue2-google-maps'
  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyCrDutt_d5HwiSO8pwRfvdtC2TSI87PMIg',
      v: '3.exp'
    }
  })
  import {db} from '../../firebase/firebase'
  import proj4 from 'proj4'
  export default {
    data () {
      return {
        wellMapId: '',
        wellsPopulated: false,
        selectedWell: '',
        selectedWellName: 'select a well',
        wells: {},
        zoom: 4,
        layer: '',
        wellData: {},
        center: {lat: 34.5199, lng: -105.8701},
        markers: [],
        options: {styles: [
          {elementType: 'geometry', stylers: [{color: '#ebe3cd'}]},
          {elementType: 'labels.text.fill', stylers: [{color: '#523735'}]},
          {elementType: 'labels.text.stroke', stylers: [{color: '#f5f1e6'}]},
          {
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [{color: '#c9b2a6'}]
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'geometry.stroke',
            stylers: [{color: '#dcd2be'}]
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [{color: '#ae9e90'}]
          },
          {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [{color: '#dfd2ae'}]
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [{color: '#dfd2ae'}]
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [{color: '#93817c'}]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry.fill',
            stylers: [{color: '#a5b076'}]
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [{color: '#447530'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{color: '#f5f1e6'}]
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [{color: '#fdfcf8'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [{color: '#f8c967'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [{color: '#e9bc62'}]
          },
          {
            featureType: 'road.highway.controlled_access',
            elementType: 'geometry',
            stylers: [{color: '#e98d58'}]
          },
          {
            featureType: 'road.highway.controlled_access',
            elementType: 'geometry.stroke',
            stylers: [{color: '#db8555'}]
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [{color: '#806b63'}]
          },
          {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [{color: '#dfd2ae'}]
          },
          {
            featureType: 'transit.line',
            elementType: 'labels.text.fill',
            stylers: [{color: '#8f7d77'}]
          },
          {
            featureType: 'transit.line',
            elementType: 'labels.text.stroke',
            stylers: [{color: '#ebe3cd'}]
          },
          {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [{color: '#dfd2ae'}]
          },
          {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [{color: '#b9d3c2'}]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [{color: '#92998d'}]
          }
        ] }
      }
    },
    components: {
      stiffDiagram,
      waterLevel
    },
    mixins: [VueGoogleMaps.MapElementMixin],
    methods: {
      wellClicked: function (wellKey) {
        this.selectedWell = wellKey
        this.selectedWellName = this.wells[wellKey].name
        this.$router.push({path: this.$route.path, query: {wellkey: this.selectedWell}})
      },
      setUpMap: function () {
        proj4.defs('google', '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs')
        proj4.defs('nat83', '+proj=utm +zone=' + this.wellData.center.zone + ' +ellps=WGS84 +datum=WGS84 +units=m +no_defs')
        let utmProject = proj4('nat83')
        let googleProject = proj4('google')
        let centerCoord = proj4(
          utmProject,
          googleProject,
          [this.wellData.center.easting, this.wellData.center.northing])
        this.center.lat = centerCoord[1]
        this.center.lng = centerCoord[0]
        this.zoom = this.wellData.zoom
      },
      populateMap: function () {
        proj4.defs('google', '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs')
        let googleProject = proj4('google')
        this.markers = []
        var well
        for (well in this.wellData.wells) {
          proj4.defs('nat83', '+proj=utm +zone=' + 13 + ' +ellps=WGS84 +datum=WGS84 +units=m +no_defs')
          let utmProject = proj4('nat83')
          let location = proj4(
            utmProject,
            googleProject,
            [this.wells[well].easting, this.wells[well].northing])

          this.markers.push({
            name: this.wells[well].name,
            wellKey: well,
            position: {
              lat: location[1],
              lng: location[0]
            }
          })
        }
      }
    },
    created: function () {
      this.wellMapId = this.$route.params.wellMapId
      if (this.$route.query != null) {
        this.wellKey = this.$route.query['wellkey']
        this.selectedWellName = this.wells[this.wellKey].name
      }
    },
    watch: {
      'wellData.wells': function () {
        if (this.wellsPopulated) {
          this.populateMap()
        }
      },
      wellData: function () {
        if (this.wellsPopulated) {
          this.setUpMap()
        }
      }
    },
    firebase: function () {
      return {
        wells: {
          source: db.ref('/projects/' + this.$route.params.projectid + '/data/well'),
          asObject: true,
          readyCallback: function () {
            this.wellsPopulated = true
            this.setUpMap()
            this.populateMap()
            if (this.$route.query != null) {
              this.wellKey = this.$route.query['wellkey']
              this.selectedWellName = this.wells[this.wellKey].name
            }
          }
        },
        wellData: {
          source: db.ref('/projects/' + this.$route.params.projectid + '/data/maps/' + this.$route.params.wellMapId),
          asObject: true
        }
      }
    }
  }
</script>

<style>
  .map-container {
    width: 500px;
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/WellMap.vue